export default "__VITE_ASSET__668f1c46__"